import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";
import type { DetailedLead, Lead } from "common/types";

async function getLead(
  workspaceId: string,
  profileId: string,
): Promise<DetailedLead> {
  return (await get(`workspaces/${workspaceId}/leads/${profileId}`)).lead;
}

export default function useLead({
  profileId,
  placeholderLead,
}: {
  profileId?: string;
  placeholderLead?: Lead;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { leadsKeys } = getQueryKeys(workspaceId);

  const {
    data: lead,
    isLoading: isLoadingLead,
    refetch: refetchLead,
    error: leadError,
  } = useQuery({
    queryKey: leadsKeys.details(profileId),
    queryFn: () => getLead(workspaceId, profileId),
    enabled: !!profileId,
    placeholderData: placeholderLead
      ? {
          ...placeholderLead,
          volunteer_experience: [],
          education: [],
          languages: [],
          skills: [],
          certifications: [],
          work_experience: [],
          current_experience: [],
          phones: [],
          is_lead: true,
          twitter_handles: [],
        }
      : undefined,
  });

  return {
    lead,
    isLoadingLead,
    refetchLead,
    leadError,
  };
}
